import React from 'react';
import { SearchCard } from '../types';
import { BaseDesktopSearchCard } from '../Base';
import {
  Price,
  GrayUIText,
  Title,
  BlackUIText,
  UnitPriceText,
  GrayPrice,
  BottomContent,
} from '../Base/styles';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import {
  BoxConditionIcon,
  CartIcon,
  DeliveryIcon,
  MapMarkerIcon,
} from '../../../../assets';
import { Pill } from '../../../basePill';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
  overflow: hidden;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
`;

const FlexContainer = styled.div<{ horizontalAlign: HorizontalAlign }>`
  display: flex;
  justify-content: ${({ horizontalAlign }) => horizontalAlign};
  align-items: center;
`;

const StyledGrayPrice = styled(GrayPrice)`
  margin-bottom: ${theme.spacings[0].rem};
`;

type HorizontalAlign = 'end' | 'space-between';

type SearchCardProps = SearchCard<'WineBuyNow'> & {
  horizontalAlign: HorizontalAlign;
};

export const WineBuyNowDesktopSearchCard: React.FC<SearchCardProps> = ({
  title,
  condition,
  location,
  isDelivery,
  grayPrice,
  data,
  type,
  horizontalAlign = 'end',
  ...props
}) => {
  return (
    <BaseDesktopSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <FlexContainer horizontalAlign={grayPrice ? 'space-between' : 'end'}>
          {grayPrice && <StyledGrayPrice>{grayPrice}</StyledGrayPrice>}
          <Pill
            backgroundColor={theme.colors.tints.systemBlue[6]}
            icon={CartIcon}
          >
            Buy Now
          </Pill>
        </FlexContainer>
        <GridContainer>
          <div>
            <Price>{data.perBottlePrice}</Price>
            <BlackUIText>
              <UnitPriceText>Per {data.unitPricing.unitName}</UnitPriceText>
            </BlackUIText>
          </div>
          <div>
            <Price>{data.secondaryPrice.price}</Price>
            <BlackUIText>
              <UnitPriceText>
                Per {data.unitPricing.unitCollectiveNoun}
              </UnitPriceText>
            </BlackUIText>
          </div>
        </GridContainer>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.neutrals.solidGrays[3]}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              <>
                <DeliveryIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                Delivery
              </>
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseDesktopSearchCard>
  );
};
